<template>
  <span class="flex items-center gap-1 text-start">
    <slot name="icon" />
    <span><slot /></span>
  </span>
</template>
